import { render, staticRenderFns } from "./VaimoCrossSellProducts.vue?vue&type=template&id=056b4be7&scoped=true&"
import script from "./VaimoCrossSellProducts.vue?vue&type=script&lang=ts&"
export * from "./VaimoCrossSellProducts.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoCrossSellProducts.vue?vue&type=style&index=0&id=056b4be7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b4be7",
  null
  
)

export default component.exports